import { CollectPaymentModuleContext } from ".";
import { ExamChargesModuleContext } from "../../examCharges/context";

// constants.ts
export const PAGE_STATE = {
    SELECT_CHARGES: "SELECT_CHARGES",
    SELECT_PAYMENT_MODE: "SELECT_PAYMENT_MODE",
    REVIEW: "REVIEW",
  };
  
 
  
 
  export const otherCharges = {
    // other charges state
  };
  